import { ColDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import { initialCrudModelBaseState, CrudModelPaginator } from '@/shared/models/cruds.models'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { customerTypesService } from '@/modules/configurationModule/detail/accounting/billable/customer-types/services/customer-types.service'
import { PaginatorDatasource } from '@/shared/resources/datasources/paginator/paginator-datasource'
import { CustomerTypeResponse } from '@/modules/configurationModule/detail/accounting/billable/customer-types/services/customer-types.dto'

export const columnsDefCustomerTypesGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.typeOfClient'),
            field: 'name',
            minWidth: 250,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.code'),
            field: 'code',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export enum CustomerTypesGridSidepanelComboElements {
    CLIENTS = 1
}

export interface CustomerTypesGridState extends CrudModelPaginator<CustomerTypeResponse> {
    service: typeof customerTypesService
}
export const initialCustomerTypesGridState =
    (): CustomerTypesGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.global.accounting.customerTypes',
        columnsDef: columnsDefCustomerTypesGrid(),
        datasource: new PaginatorDatasource(customerTypesService),
        service: customerTypesService,
        visibleSidePanel: false
    })
